import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

const opts = {
  theme: {
    themes: {
      light: {
        primary: '#1976d2',
        secondary: '#265eb8',
        secondaryText: '#265eb8',
      },
    },
  },
};

export default new Vuetify(opts);
